// เนื้อเรื่องแมง (แมงมุม แมงป่อง ไรและเห็บ) และตะขาบกิ้งกือ

import type { GameEvent } from "../../engine/types";

const A = ["ARACHNID"] as const;
const M = ["MYRIAPOD"] as const;
const TICKS = ["Ixodidae", "Argasidae"];

export const ARACHNID_MYRIAPOD_EVENTS: readonly GameEvent[] = [
  // ---------- แมงทั่วไป ----------
  {
    id: "arachnid_molt",
    archetypes: A,
    stageTags: ["young"],
    weight: 5,
    text: "เปลือกของคุณคับแน่นจนขยับตัวลำบาก ถึงเวลาลอกคราบแล้ว",
    fact: "แมงมุมและแมงป่องต้องลอกคราบเพื่อโต ระหว่างนั้นเปลือกใหม่ยังนิ่ม จึงเป็นช่วงที่อ่อนแอที่สุด",
    choices: [
      {
        label: "หาที่ซ่อนก่อนลอก",
        outcomes: [
          { chance: 0.9, text: "คุณลอกคราบอย่างปลอดภัย ตัวใหญ่ขึ้นอีกขั้น", effects: { health: 10, fullness: -10 } },
          { chance: 0.1, text: "คราบเก่าติดขาข้างหนึ่งจนหลุดออกไป", effects: { health: -20, cause: "accident" } },
        ],
      },
      {
        label: "ลอกตรงนี้เลย",
        outcomes: [
          { chance: 0.7, text: "คุณลอกคราบเสร็จอย่างรวดเร็ว", effects: { health: 10 } },
          { chance: 0.3, text: "มดเจอคุณตอนตัวยังนิ่ม", effects: { health: -30, cause: "predator" } },
        ],
      },
    ],
  },

  // ---------- แมงมุม ----------
  {
    id: "spider_ballooning",
    opening: true,
    archetypes: A,
    stages: ["spiderling"],
    requires: { subgroups: ["arachnid.spider"] },
    weight: 10,
    text: "พี่น้องนับร้อยไต่ขึ้นยอดหญ้า ยกก้นขึ้นฟ้า แล้วปล่อยเส้นใยให้ลมพัด",
    fact: "ลูกแมงมุมหลายชนิดปล่อยเส้นใยให้ลมพาลอยไปได้ไกลหลายกิโลเมตร เรียกว่าการบอลลูน",
    choices: [
      {
        label: "ปล่อยใยให้ลมพาไป",
        outcomes: [
          { chance: 0.7, text: "คุณลอยข้ามทุ่งไปตกในพุ่มไม้ที่ไม่มีพี่น้องมาแย่งอาหาร", effects: { move: "far", safety: 10, fullness: 10 } },
          { chance: 0.3, text: "ลมพัดคุณไปตกกลางแอ่งน้ำ กว่าจะคลานขึ้นฝั่งได้ก็หมดแรง", effects: { health: -20, cause: "accident" } },
        ],
      },
      {
        label: "ไต่ไปตามพื้นแทน",
        outcomes: [
          { chance: 0.6, text: "คุณหาที่อยู่ใกล้ๆ ได้ แต่ต้องแย่งแมลงกับพี่น้อง", effects: { fullness: 5 } },
          { chance: 0.4, text: "พี่ของคุณที่หิวโหยจ้องจะกินคุณ", effects: { health: -15, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "spider_web",
    archetypes: A,
    stages: ["spiderling", "adult", "elder"],
    requires: { subgroups: ["arachnid.spider"] },
    weight: 9,
    text: "คุณขึงใยเสร็จพอดีตอนรุ่งสาง หยดน้ำค้างเกาะเส้นใยเป็นประกาย",
    fact: "ใยแมงมุมบางชนิดเหนียวกว่าเหล็กกล้าเมื่อเทียบน้ำหนักเท่ากัน",
    choices: [
      {
        label: "เกาะนิ่งรอกลางใย",
        outcomes: [
          { chance: 0.7, text: "แมลงวันตัวอ้วนบินมาติดใย คุณพันมันด้วยใยแล้วกินอย่างช้าๆ", effects: { fullness: 35 } },
          { chance: 0.3, text: "นกตัวเล็กสังเกตเห็นคุณกลางใย คุณทิ้งตัวหนีลงพื้นทัน", effects: { safety: -15 } },
        ],
      },
      { label: "ซ่อนใต้ใบไม้ข้างใย", outcomes: [{ chance: 1, text: "คุณรอให้ใยสั่นแล้วค่อยออกไป ได้อาหารน้อยกว่าแต่ปลอดภัย", effects: { fullness: 20, safety: 10 } }] },
    ],
  },
  {
    id: "spider_web_broken",
    archetypes: A,
    stages: ["spiderling", "adult", "elder"],
    requires: { subgroups: ["arachnid.spider"] },
    weight: 5,
    text: "ลมแรงเมื่อคืนพัดใยของคุณขาดเป็นรู",
    fact: "แมงมุมหลายชนิดกินใยเก่าของตัวเอง เพื่อนำโปรตีนกลับมาสร้างใยใหม่",
    choices: [
      { label: "กินใยเก่าแล้วสร้างใหม่", outcomes: [{ chance: 1, text: "คุณได้โปรตีนคืนมาส่วนหนึ่ง และใยใหม่ก็แข็งแรงกว่าเดิม", effects: { fullness: 5, safety: 5 } }] },
      {
        label: "ย้ายไปขึงใยที่ใหม่",
        outcomes: [
          { chance: 0.6, text: "ที่ใหม่มีแมลงบินผ่านเยอะกว่าเดิม", effects: { move: "near", fullness: 25 } },
          { chance: 0.4, text: "ระหว่างทางคุณเกือบโดนจิ้งจกงับ", effects: { safety: -15 } },
        ],
      },
    ],
  },
  {
    id: "spider_wasp",
    archetypes: A,
    stages: ["spiderling", "adult"],
    requires: { subgroups: ["arachnid.spider"] },
    weight: 3,
    text: "ต่อตัวสีดำขายาวเดินวนหาอะไรบางอย่างบนพื้น หนวดของมันสั่นไม่หยุด",
    fact: "ต่อล่าแมงมุมต่อยให้แมงมุมเป็นอัมพาต แล้ววางไข่ไว้บนตัว ตัวอ่อนต่อจะค่อยๆ กินแมงมุมที่ยังมีชีวิต",
    choices: [
      {
        label: "ทิ้งตัวจากใยหนีทันที",
        outcomes: [
          { chance: 0.75, text: "คุณร่วงลงไปซ่อนในกองใบไม้ ต่อหาคุณไม่เจอ", effects: { safety: 5 } },
          { chance: 0.25, text: "ต่อตามมาต่อยคุณจนขยับไม่ได้", effects: { death: "predator" } },
        ],
      },
      {
        label: "ยกขาหน้าขึ้นขู่",
        outcomes: [
          { chance: 0.4, text: "ต่อลังเลแล้วเดินจากไปหาเหยื่อตัวอื่น" },
          { chance: 0.6, text: "ต่อพุ่งเข้าใส่ คุณดิ้นหลุดมาได้แต่ขาหักไปหนึ่งขา", effects: { health: -30, addFlags: ["injured"], cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "spider_courtship",
    archetypes: A,
    stages: ["adult"],
    requires: { subgroups: ["arachnid.spider"], notFlags: ["has_mate"] },
    weight: 14,
    text: "มีแมงมุมอีกตัวมาเกาะอยู่ที่ขอบใย และเริ่มดีดเส้นใยเป็นจังหวะ",
    fact: "แมงมุมตัวผู้หลายชนิดต้องเต้นหรือดีดใยเป็นจังหวะให้ตัวเมียรู้ว่าไม่ใช่เหยื่อ ไม่เช่นนั้นอาจถูกกิน",
    choices: [
      {
        label: "ดีดใยตอบตามจังหวะ",
        outcomes: [
          { chance: 0.8, text: "จังหวะตรงกัน คุณได้คู่แล้ว", effects: { addFlags: ["has_mate"] } },
          { chance: 0.2, text: "อีกตัวไม่เข้าใจจังหวะของคุณ และเกือบกลายเป็นมื้ออาหาร", effects: { health: -15, cause: "predator" } },
        ],
      },
      { label: "ไม่สนใจ", outcomes: [{ chance: 1, text: "อีกตัวรออยู่พักหนึ่งแล้วไต่จากไป" }] },
    ],
  },
  {
    id: "spider_egg_sac",
    archetypes: A,
    stages: ["adult"],
    requires: { subgroups: ["arachnid.spider"], flags: ["has_mate"] },
    weight: 30,
    text: "ท้องของคุณเต็มไปด้วยไข่ ถึงเวลาสร้างถุงไข่แล้ว",
    choices: [
      { label: "ห่อไข่ด้วยใยแล้วซ่อนไว้ใต้ใบไม้", outcomes: [{ chance: 1, text: "คุณห่อไข่ {n} ฟองไว้ในถุงใยนุ่มแน่น", effects: { offspring: "clutch", fullness: -15, removeFlags: ["has_mate"], addFlags: ["parent"] } }] },
      { label: "พกถุงไข่ติดตัวไปด้วย", outcomes: [{ chance: 1, text: "คุณใช้เขี้ยวคาบถุงไข่ {n} ฟองไว้ตลอดเวลา ไปไหนก็พาไปด้วย", effects: { offspring: "clutch", fullness: -20, safety: -5, removeFlags: ["has_mate"], addFlags: ["parent"] } }] },
    ],
  },

  // ---------- แมงป่อง ----------
  {
    id: "scorpion_back",
    opening: true,
    archetypes: A,
    stages: ["newborn"],
    requires: { subgroups: ["arachnid.scorpion"] },
    weight: 10,
    text: "คุณกับพี่น้องเกาะกันแน่นอยู่บนหลังแม่ แม่ยกก้ามขึ้นทุกครั้งที่มีอะไรเคลื่อนไหว",
    fact: "ลูกแมงป่องแรกเกิดตัวนิ่มและยังไม่มีพิษ จึงต้องเกาะหลังแม่จนกว่าจะลอกคราบครั้งแรก",
    choices: [
      { label: "เกาะให้แน่นตรงกลางหลัง", outcomes: [{ chance: 1, text: "ตรงกลางหลังแม่เป็นที่ที่ปลอดภัยที่สุด", effects: { safety: 15 } }] },
      {
        label: "ปีนไปเกาะใกล้หาง",
        outcomes: [
          { chance: 0.7, text: "คุณเห็นแม่ใช้เหล็กในจัดการตะขาบตัวหนึ่ง", effects: { safety: 5 } },
          { chance: 0.3, text: "คุณหล่นจากหลังแม่ กว่าจะปีนกลับขึ้นไปได้ก็หอบ", effects: { health: -15, safety: -10, cause: "accident" } },
        ],
      },
    ],
  },
  {
    id: "scorpion_ride",
    archetypes: A,
    stages: ["newborn"],
    requires: { subgroups: ["arachnid.scorpion"] },
    weight: 6,
    text: "คืนนี้แม่ออกล่าทั้งที่ยังมีพวกคุณอยู่บนหลัง",
    choices: [
      {
        label: "เกาะนิ่งๆ ไม่ขยับ",
        outcomes: [
          { chance: 0.85, text: "แม่จับจิ้งหรีดได้ และกลับถึงโพรงอย่างปลอดภัย", effects: { safety: 5 } },
          { chance: 0.15, text: "แม่ต้องวิ่งหนีกะทันหัน คุณกระเด็นตกลงพื้นมืดๆ", effects: { health: -25, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "scorpion_uv",
    archetypes: A,
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["arachnid.scorpion"] },
    weight: 4,
    text: "คืนเดือนหงาย แสงจันทร์สาดลงมาบนพื้นทราย",
    fact: "แมงป่องเรืองแสงสีฟ้าอมเขียวเมื่อโดนแสงอัลตราไวโอเลต นักวิทยาศาสตร์จึงใช้ไฟแบล็กไลต์ส่องหาแมงป่องตอนกลางคืน",
    choices: [
      { label: "รอให้มืดกว่านี้ค่อยออกล่า", outcomes: [{ chance: 1, text: "คุณออกล่าตอนเมฆบังจันทร์ ได้จิ้งหรีดมาหนึ่งตัว", effects: { fullness: 20, safety: 5 } }] },
      {
        label: "ออกล่าเลย",
        outcomes: [
          { chance: 0.6, text: "เหยื่อเยอะกว่าคืนอื่น คุณกินจนอิ่ม", effects: { fullness: 35 } },
          { chance: 0.4, text: "นกเค้าแมวมองเห็นคุณชัดเจนใต้แสงจันทร์", effects: { health: -25, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "scorpion_hunt",
    archetypes: A,
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["arachnid.scorpion"] },
    weight: 7,
    text: "คุณรู้สึกถึงแรงสั่นสะเทือนเบาๆ ผ่านพื้นดิน มีบางอย่างเดินอยู่ใกล้ๆ",
    fact: "แมงป่องตาไม่ดีนัก แต่รับรู้แรงสั่นสะเทือนจากพื้นได้ไวมาก จึงรู้ได้ว่าเหยื่ออยู่ทางไหน",
    choices: [
      {
        label: "ใช้ก้ามหนีบ",
        outcomes: [
          { chance: 0.7, text: "ก้ามหนีบแมลงสาบไว้แน่น ไม่ต้องเปลืองพิษเลย", effects: { fullness: 30 } },
          { chance: 0.3, text: "เหยื่อคือตะขาบตัวใหญ่ มันกัดคุณก่อน", effects: { health: -20, cause: "predator" } },
        ],
      },
      { label: "ต่อยด้วยเหล็กใน", outcomes: [{ chance: 1, text: "พิษทำงานอย่างรวดเร็ว คุณได้อาหาร แต่ต้องรอหลายวันกว่าพิษจะเติมกลับ", effects: { fullness: 30, safety: -5 } }] },
    ],
  },
  {
    id: "scorpion_fast",
    archetypes: A,
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["arachnid.scorpion"] },
    weight: 3,
    text: "หลายสัปดาห์แล้วที่ไม่มีเหยื่อเดินผ่านโพรงของคุณเลย",
    fact: "แมงป่องบางชนิดอยู่ได้นานหลายเดือนโดยไม่กินอาหาร เพราะเผาผลาญพลังงานต่ำมาก",
    choices: [
      { label: "อยู่นิ่งในโพรง ประหยัดพลังงาน", outcomes: [{ chance: 1, text: "ร่างกายของคุณแทบไม่ใช้พลังงานเลย คุณรอได้อีกนาน", effects: { fullness: 15, health: 5 } }] },
      {
        label: "ออกไปหาที่ล่าใหม่",
        outcomes: [
          { chance: 0.5, text: "คุณเจอที่ใหม่ที่มีแมลงชุกชุม", effects: { move: "near", fullness: 30 } },
          { chance: 0.5, text: "แมงป่องเจ้าถิ่นตัวใหญ่ไม่ยอมให้คุณเข้ามา", effects: { health: -15, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "scorpion_dance",
    archetypes: A,
    stages: ["adult"],
    requires: { subgroups: ["arachnid.scorpion"], notFlags: ["has_mate"] },
    weight: 14,
    text: "แมงป่องอีกตัวเดินเข้ามาใกล้ แล้วยื่นก้ามมาจับก้ามของคุณ",
    fact: "แมงป่องผสมพันธุ์ด้วยการจับก้ามกันเดินไปมาคล้ายเต้นรำ ตัวผู้วางถุงสเปิร์มลงพื้น แล้วพาตัวเมียเดินไปเหนือมัน",
    choices: [
      {
        label: "เดินเต้นรำไปด้วยกัน",
        outcomes: [
          { chance: 0.85, text: "พวกคุณเต้นรำอยู่นานจนรุ่งเช้า และผสมพันธุ์สำเร็จ", effects: { addFlags: ["has_mate"], fullness: -10 } },
          { chance: 0.15, text: "ระหว่างเต้น อีกฝ่ายต่อยคุณเข้าให้", effects: { health: -20, cause: "accident" } },
        ],
      },
      { label: "สะบัดก้ามหนี", outcomes: [{ chance: 1, text: "คุณเดินจากมาคนเดียว" }] },
    ],
  },
  {
    id: "scorpion_birth",
    archetypes: A,
    stages: ["adult"],
    requires: { subgroups: ["arachnid.scorpion"], flags: ["has_mate"] },
    weight: 30,
    text: "หลายเดือนหลังผสมพันธุ์ ท้องของคุณใหญ่จนเดินช้าลง",
    fact: "แมงป่องไม่วางไข่ แต่ออกลูกเป็นตัว แล้วลูกๆ จะปีนขึ้นมาเกาะบนหลังแม่",
    choices: [
      { label: "คลอดในโพรงลึก", outcomes: [{ chance: 1, text: "ลูก {n} ตัวปีนขึ้นมาเกาะบนหลังคุณจนแน่น", effects: { offspring: "clutch", fullness: -20, removeFlags: ["has_mate"], addFlags: ["parent"] } }] },
      {
        label: "คลอดใต้ก้อนหินใกล้ๆ",
        outcomes: [
          { chance: 0.8, text: "ลูก {n} ตัวปีนขึ้นหลังคุณอย่างปลอดภัย", effects: { offspring: "clutch", fullness: -10, removeFlags: ["has_mate"], addFlags: ["parent"] } },
          { chance: 0.2, text: "มดเจอที่ซ่อนของคุณ แต่ลูก {n} ตัวก็ปีนขึ้นหลังได้ทัน", effects: { offspring: "clutch", health: -15, removeFlags: ["has_mate"], addFlags: ["parent"], cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "scorpion_collect",
    archetypes: A,
    stages: ["adult", "elder"],
    requires: { subgroups: ["arachnid.scorpion"] },
    weight: 2,
    threatenedWeight: 2,
    text: "มีคนถือไฟฉายเดินส่องตามพื้นป่า และพลิกก้อนหินทีละก้อน",
    choices: [
      {
        label: "มุดลึกลงไปในโพรง",
        outcomes: [
          { chance: 0.8, text: "พวกเขาเดินผ่านโพรงของคุณไป", effects: { safety: 5 } },
          { chance: 0.2, text: "พวกเขาขุดโพรงของคุณ แล้วจับคุณใส่ขวด", effects: { death: "human" } },
        ],
      },
      {
        label: "ยกเหล็กในขู่",
        outcomes: [
          { chance: 0.5, text: "พวกเขาถอยห่างแล้วเดินไปทางอื่น" },
          { chance: 0.5, text: "พวกเขาใช้คีมคีบคุณไปขาย", effects: { death: "human" } },
        ],
      },
    ],
  },

  // ---------- ไรและเห็บ ----------
  {
    id: "mite_tiny",
    archetypes: A,
    stages: ["larva", "nymph", "adult"],
    requires: { subgroups: ["arachnid.mite_tick"] },
    weight: 6,
    text: "คุณตัวเล็กกว่าเม็ดทราย โลกทั้งใบของคุณคือเศษใบไม้กองเดียว",
    fact: "ไรส่วนใหญ่ตัวเล็กไม่ถึงหนึ่งมิลลิเมตร ในดินหนึ่งกำมืออาจมีไรอยู่หลายร้อยตัว",
    choices: [
      { label: "กินเชื้อราบนใบไม้", outcomes: [{ chance: 1, text: "เส้นใยราเป็นอาหารชั้นดีสำหรับตัวเล็กอย่างคุณ", effects: { fullness: 30 } }] },
      {
        label: "ไต่ขึ้นไปหาที่ใหม่",
        outcomes: [
          { chance: 0.6, text: "คุณเกาะขาด้วงที่เดินผ่าน แล้วติดไปถึงกองใบไม้กองใหม่", effects: { fullness: 15, safety: 5 } },
          { chance: 0.4, text: "หางดีดตัวหนึ่งเจอคุณระหว่างทาง", effects: { health: -25, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "tick_questing",
    archetypes: A,
    stages: ["larva", "nymph", "adult"],
    requires: { subgroups: ["arachnid.mite_tick"], families: TICKS },
    weight: 10,
    text: "คุณไต่ขึ้นไปเกาะปลายใบหญ้า กางขาคู่หน้ารอสัตว์เดินผ่าน",
    fact: "เห็บรับรู้คาร์บอนไดออกไซด์และความร้อนจากลมหายใจของสัตว์ ด้วยอวัยวะรับกลิ่นพิเศษที่ขาคู่หน้า",
    choices: [
      {
        label: "รอต่อไปอย่างอดทน",
        outcomes: [
          { chance: 0.6, text: "กวางตัวหนึ่งเดินเฉียดมา คุณเกาะติดขนมันได้ แล้วดูดเลือดจนตัวพอง", effects: { fullness: 50 } },
          { chance: 0.4, text: "รอนานหลายวันไม่มีใครผ่านมา คุณต้องลงไปหลบแดดที่โคนหญ้า", effects: { fullness: -5, health: -5 } },
        ],
      },
      {
        label: "ไต่ไปหาทางเดินของสัตว์",
        outcomes: [
          { chance: 0.5, text: "หมูป่าเดินผ่านมา คุณเกาะติดขามันได้ และดูดเลือดจนอิ่ม", effects: { fullness: 45 } },
          { chance: 0.5, text: "นกที่คุ้ยหาแมลงจิกคุณกินไปพร้อมกับใบไม้", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "tick_groomed",
    archetypes: A,
    stages: ["larva", "nymph", "adult"],
    requires: { subgroups: ["arachnid.mite_tick"], families: TICKS },
    weight: 5,
    text: "สัตว์ที่คุณเกาะอยู่เริ่มเลียและเกาตัวอย่างหงุดหงิด",
    choices: [
      {
        label: "ฝังปากให้ลึกกว่าเดิม",
        outcomes: [
          { chance: 0.7, text: "ปากที่มีเงี่ยงของคุณยึดผิวหนังไว้แน่น มันเกาคุณไม่หลุด", effects: { fullness: 20 } },
          { chance: 0.3, text: "ลิ้นของมันกวาดคุณหลุดไปพร้อมขนกระจุกหนึ่ง", effects: { death: "predator" } },
        ],
      },
      { label: "ปล่อยตัวหล่นลงพื้น", outcomes: [{ chance: 1, text: "คุณหล่นลงพงหญ้าอย่างปลอดภัย แต่ต้องเริ่มรอเหยื่อใหม่", effects: { fullness: -10, safety: 5 } }] },
    ],
  },

  // ---------- แมงอื่นๆ ----------
  {
    id: "arachnid_other_night",
    archetypes: A,
    stages: ["spiderling", "adult", "elder"],
    requires: { subgroups: ["arachnid.other"] },
    weight: 7,
    text: "คืนนี้ชื้นและมืดสนิท เหมาะกับการออกล่าตามพื้นป่า",
    fact: "แมงป่องแส้บางชนิดพ่นสารที่มีกรดน้ำส้มเข้มข้นใส่ศัตรู จึงได้ชื่อภาษาอังกฤษว่า vinegaroon",
    choices: [
      {
        label: "คลำทางด้วยขาคู่หน้า",
        outcomes: [
          { chance: 0.8, text: "ขาคู่หน้าที่ยาวเหมือนหนวดพาคุณไปเจอจิ้งหรีดที่ซ่อนอยู่", effects: { fullness: 30 } },
          { chance: 0.2, text: "คุณคลำไปเจอคางคกเข้า แต่พ่นสารฉุนใส่หน้ามันทัน", effects: { safety: -10, fullness: 5 } },
        ],
      },
      { label: "ซุ่มรอใต้ขอนไม้", outcomes: [{ chance: 1, text: "แมลงสาบเดินมาหาคุณเอง", effects: { fullness: 20, safety: 5 } }] },
    ],
  },
  {
    id: "pseudoscorpion_ride",
    archetypes: A,
    stages: ["spiderling", "adult"],
    requires: { subgroups: ["arachnid.other"] },
    weight: 4,
    text: "ที่นี่อาหารเริ่มหมด แมลงวันตัวหนึ่งเพิ่งเกาะลงข้างๆ คุณ",
    fact: "แมงป่องเทียมตัวจิ๋วบางชนิดใช้ก้ามหนีบขาแมลงวันหรือด้วงไว้ เพื่อติดไปยังที่ใหม่",
    choices: [
      {
        label: "หนีบขาแมลงวันไว้",
        outcomes: [
          { chance: 0.7, text: "แมลงวันบินพาคุณไปถึงกองปุ๋ยหมักที่มีอาหารเต็มไปหมด", effects: { move: "near", fullness: 30 } },
          { chance: 0.3, text: "คุณหลุดกลางอากาศ ร่วงลงมาในที่ที่ไม่รู้จัก", effects: { health: -15, safety: -10, cause: "accident" } },
        ],
      },
      { label: "อยู่ที่เดิม", outcomes: [{ chance: 1, text: "คุณหาไรตัวเล็กๆ กินพอประทังชีวิต", effects: { fullness: 10 } }] },
    ],
  },

  // ---------- ตะขาบและกิ้งกือทั่วไป ----------
  {
    id: "myriapod_molt",
    archetypes: M,
    stages: ["juvenile"],
    weight: 5,
    text: "คุณขุดห้องเล็กๆ ใต้ดินเพื่อลอกคราบอย่างปลอดภัย",
    choices: [
      { label: "ปิดห้องให้มิดชิด", outcomes: [{ chance: 1, text: "คุณลอกคราบเสร็จ แล้วกินคราบเก่าเพื่อเอาแร่ธาตุกลับคืน", effects: { health: 10, fullness: 5 } }] },
      {
        label: "รีบลอกแล้วออกไปหาอาหาร",
        outcomes: [
          { chance: 0.7, text: "คุณประหยัดเวลาได้มาก", effects: { fullness: 15 } },
          { chance: 0.3, text: "ลำตัวที่ยังนิ่มโดนมดรุมกัด", effects: { health: -25, cause: "predator" } },
        ],
      },
    ],
  },

  // ---------- ตะขาบ ----------
  {
    id: "centipede_mother",
    opening: true,
    archetypes: M,
    stages: ["juvenile"],
    requires: { subgroups: ["myriapod.centipede"] },
    weight: 10,
    text: "แม่ขดตัวโอบคุณกับพี่น้องไว้ตรงกลาง คอยเลียทำความสะอาดไม่ให้ขึ้นรา",
    fact: "แม่ตะขาบหลายชนิดขดตัวเฝ้าไข่และลูกอ่อนนานหลายสัปดาห์ โดยไม่ออกไปหาอาหารเลย",
    choices: [
      { label: "อยู่ในอ้อมกอดแม่จนแข็งแรง", outcomes: [{ chance: 1, text: "คุณลอกคราบครั้งแรกอย่างปลอดภัยภายใต้การเฝ้าของแม่", effects: { safety: 15, health: 5 } }] },
      {
        label: "คลานออกไปสำรวจก่อนพี่น้อง",
        outcomes: [
          { chance: 0.6, text: "คุณเจอตัวอ่อนแมลงตัวจิ๋วเป็นเหยื่อแรก", effects: { fullness: 20 } },
          { chance: 0.4, text: "แมงมุมใต้ใบไม้รอคุณอยู่", effects: { health: -25, cause: "predator" } },
        ],
      },
    ],
  },
  {
    id: "centipede_venom",
    archetypes: M,
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["myriapod.centipede"] },
    weight: 8,
    text: "จิ้งหรีดตัวหนึ่งเดินผ่านหน้าคุณไปอย่างไม่รู้ตัว",
    fact: "เขี้ยวพิษของตะขาบไม่ใช่ปาก แต่เป็นขาคู่แรกที่เปลี่ยนรูปไปเป็นคีมฉีดพิษ",
    choices: [
      {
        label: "พุ่งเข้าใส่ด้วยความเร็ว",
        outcomes: [
          { chance: 0.85, text: "คีมพิษของคุณจับเหยื่อไว้แน่น พิษทำงานในไม่กี่วินาที", effects: { fullness: 35 } },
          { chance: 0.15, text: "จิ้งหรีดดีดตัวหนี ขาหลังของมันเตะโดนหัวคุณ", effects: { fullness: 5, health: -10, cause: "accident" } },
        ],
      },
      { label: "รอให้มันเข้ามาใกล้กว่านี้", outcomes: [{ chance: 1, text: "มันเดินมาชนคุณพอดี มื้อนี้ง่ายมาก", effects: { fullness: 25, safety: 5 } }] },
    ],
  },
  {
    id: "centipede_big_prey",
    archetypes: M,
    stages: ["adult", "elder"],
    requires: { subgroups: ["myriapod.centipede"], families: ["Scolopendridae"] },
    weight: 5,
    text: "ลูกหนูตัวหนึ่งหลงเข้ามาในซอกหินที่คุณซ่อนอยู่",
    fact: "ตะขาบยักษ์บางชนิดล่ากบ หนู หรือแม้แต่ค้างคาวกินเป็นอาหารได้",
    choices: [
      {
        label: "พันตัวมันแล้วฉีดพิษ",
        outcomes: [
          { chance: 0.7, text: "เหยื่อตัวใหญ่ขนาดนี้ทำให้คุณอิ่มไปหลายวัน", effects: { fullness: 50 } },
          { chance: 0.3, text: "หนูดิ้นแรงจนกัดลำตัวคุณเป็นแผล", effects: { fullness: 20, health: -20, cause: "accident" } },
        ],
      },
      { label: "ปล่อยไป หาเหยื่อเล็กกว่านี้", outcomes: [{ chance: 1, text: "คุณจับแมลงสาบกินแทน", effects: { fullness: 20 } }] },
    ],
  },
  {
    id: "centipede_house",
    archetypes: M,
    stages: ["adult", "elder"],
    requires: { subgroups: ["myriapod.centipede"], habitat: ["urban", "forest"] },
    weight: 3,
    text: "ฝนตกหนักจนน้ำท่วมโพรง คุณหนีเข้าไปในบ้านคน",
    choices: [
      {
        label: "ซ่อนในรองเท้าที่วางอยู่หน้าบ้าน",
        outcomes: [
          { chance: 0.6, text: "ในบ้านมีแมลงสาบให้กินเยอะ คุณรอจนฝนหยุดแล้วค่อยออกมา", effects: { fullness: 30 } },
          { chance: 0.4, text: "เจ้าของบ้านสวมรองเท้า กรีดร้อง แล้วตีคุณด้วยไม้กวาด", effects: { health: -30, cause: "human" } },
        ],
      },
      { label: "อยู่ใต้กองไม้นอกบ้าน", outcomes: [{ chance: 1, text: "ที่นี่เปียกแต่ปลอดภัย", effects: { safety: 5 } }] },
    ],
  },

  // ---------- กิ้งกือ ----------
  {
    id: "millipede_segments",
    archetypes: M,
    stages: ["juvenile"],
    requires: { subgroups: ["myriapod.millipede"] },
    weight: 6,
    text: "คุณเพิ่งลอกคราบ และนับได้ว่ามีขาเพิ่มขึ้นอีกหลายคู่",
    fact: "แม้ชื่อภาษาอังกฤษจะแปลว่าพันขา แต่กิ้งกือส่วนใหญ่มีขาไม่กี่สิบถึงไม่กี่ร้อยขา ชนิดที่มีขามากที่สุดที่เคยพบมี 1,306 ขา",
    choices: [
      { label: "ลองเดินด้วยขาชุดใหม่", outcomes: [{ chance: 1, text: "ขาของคุณขยับเป็นคลื่นพร้อมกัน ดันตัวมุดลงดินได้ง่ายขึ้น", effects: { safety: 10, fullness: 5 } }] },
      { label: "กินคราบเก่าก่อน", outcomes: [{ chance: 1, text: "คราบเก่ามีแคลเซียมที่ช่วยให้เปลือกใหม่แข็งเร็วขึ้น", effects: { health: 10 } }] },
    ],
  },
  {
    id: "millipede_defense",
    archetypes: M,
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["myriapod.millipede"] },
    weight: 8,
    text: "ไก่ป่าตัวหนึ่งคุ้ยใบไม้มาเจอคุณเข้าพอดี",
    fact: "กิ้งกือหลายชนิดปล่อยสารเคมีกลิ่นฉุนออกมาป้องกันตัว บางชนิดมีสารประกอบไซยาไนด์",
    choices: [
      {
        label: "ขดตัวเป็นวง",
        outcomes: [
          { chance: 0.75, text: "เปลือกแข็งด้านนอกปกป้องขาและท้องที่นิ่มไว้ ไก่จิกไม่เข้าแล้วเดินจากไป", effects: { safety: 5 } },
          { chance: 0.25, text: "ไก่คาบคุณขึ้นไปฟาดกับพื้นหลายครั้ง", effects: { health: -30, cause: "predator" } },
        ],
      },
      {
        label: "ปล่อยสารฉุนออกมา",
        outcomes: [
          { chance: 0.9, text: "ไก่สะบัดหัวหนีกลิ่นเหม็นทันที", effects: { safety: 10, fullness: -5 } },
          { chance: 0.1, text: "ไก่ตัวนี้ไม่สนกลิ่น", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "millipede_litter",
    archetypes: M,
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["myriapod.millipede"] },
    weight: 7,
    text: "ใบไม้ร่วงกองหนาเริ่มผุนิ่มหลังฝนตก",
    fact: "กิ้งกือกินใบไม้และไม้ผุ แล้วถ่ายออกมาเป็นเม็ดเล็กๆ ที่ช่วยให้เศษพืชย่อยสลายกลายเป็นดินเร็วขึ้น",
    choices: [
      { label: "กินใบไม้ผุให้อิ่ม", outcomes: [{ chance: 1, text: "ใบไม้นิ่มกินง่าย คุณกินจนท้องตึง", effects: { fullness: 35 } }] },
      { label: "มุดลงไปกินใต้กองใบไม้", outcomes: [{ chance: 1, text: "ข้างใต้ชื้นและปลอดภัยจากนก", effects: { fullness: 20, safety: 10 } }] },
    ],
  },
  {
    id: "millipede_rain",
    archetypes: M,
    stages: ["adult"],
    requires: { subgroups: ["myriapod.millipede"] },
    weight: 4,
    text: "ฝนแรกของฤดูมาแล้ว กิ้งกือนับร้อยพากันคลานออกมาจากดิน",
    choices: [
      {
        label: "คลานข้ามลานโล่งไปหาคู่",
        outcomes: [
          { chance: 0.7, text: "คุณเจอกิ้งกืออีกตัวที่กำลังหาคู่เหมือนกัน", effects: { addFlags: ["has_mate"], fullness: -10 } },
          { chance: 0.3, text: "แดดออกกะทันหัน ลานโล่งร้อนจนคุณเกือบแห้งตาย", effects: { health: -25, cause: "disaster" } },
        ],
      },
      { label: "อยู่ใต้ใบไม้ รอให้คนอื่นมาหา", outcomes: [{ chance: 1, text: "คุณได้กินใบไม้ชุ่มฝนอย่างสบาย", effects: { fullness: 20 } }] },
    ],
  },

  // ---------- สัตว์หลายขาอื่นๆ ----------
  {
    id: "myriapod_soil_tiny",
    archetypes: M,
    stages: ["juvenile", "adult", "elder"],
    requires: { subgroups: ["myriapod.other"] },
    weight: 7,
    text: "คุณตัวขาวใสยาวไม่กี่มิลลิเมตร ไต่ไปตามช่องว่างระหว่างเม็ดดิน",
    choices: [
      { label: "กินรากฝอยและเชื้อรา", outcomes: [{ chance: 1, text: "ใต้ดินมีอาหารมากมายสำหรับตัวเล็กอย่างคุณ", effects: { fullness: 30 } }] },
      {
        label: "มุดลงไปที่ชื้นกว่า",
        outcomes: [
          { chance: 0.8, text: "ดินชั้นล่างชื้นกำลังดีและปลอดภัย", effects: { safety: 10, fullness: 10 } },
          { chance: 0.2, text: "คุณเจอไรตัวห้ำที่ล่าสัตว์ตัวเล็กในดิน", effects: { health: -20, cause: "predator" } },
        ],
      },
    ],
  },
];
